import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

const TONES = {
  primary: { tile: 'bg-primary bg-opacity-5', value: 'text-primary', icon: 'bg-primary' },
  success: { tile: 'bg-success bg-opacity-5', value: 'text-success', icon: 'bg-success' },
  warning: { tile: 'bg-orange-500 bg-opacity-5', value: 'text-orange-500', icon: 'bg-orange-500' },
  purple: { tile: 'bg-purple bg-opacity-5', value: 'text-purple', icon: 'bg-purple' }
}

function Tile({ icon: Icon, label, value, hint, tone = 'primary' }) {
  const { tile, value: valueColor, icon: iconBg } = TONES[tone] || TONES.primary

  return (
    <div className={`w-full rounded-2xl p-4 ${tile}`}>
      <div className="flex items-start justify-between mb-1">
        <p className="text-sm text-secondary">{label}</p>

        {
          Icon && (
            <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${iconBg}`}>
              <Icon size={18} className="text-white" />
            </div>
          )
        }
      </div>

      <p className={`text-xl font-bold ${valueColor}`}>{value}</p>
      {hint && <p className="text-xs text-secondary mt-1">{hint}</p>}
    </div>
  )
}

export default withTranslation()(function PayoutStats({
  t,
  totalPayoutsMonth = 'GHS 0.00',
  upcomingPayouts = 'GHS 0.00',
  pendingApproval = 'GHS 0.00',
  lastPayoutDate = '--',
  totalWinners = 0,
  paidWinners = 0,
  paidWinnersPercent = 0,
  pendingWinners = 0,
  pendingWinnersPercent = 0,
  prizeTypes = 0
}) {
  return (
    <div className="flex flex-col gap-4 mb-5">
      <div className="grid gap-4 md:grid-cols-4">
        <Tile icon={UIcons.UilWallet} label={t('payout.stats.total_payouts_month')} value={totalPayoutsMonth} hint={t('payout.stats.total_payouts_month_hint')} tone="primary" />
        <Tile icon={UIcons.UilCalendarAlt} label={t('payout.stats.upcoming_payouts')} value={upcomingPayouts} hint={t('payout.stats.upcoming_payouts_hint')} tone="purple" />
        <Tile icon={UIcons.UilClockThree} label={t('payout.stats.pending_approval')} value={pendingApproval} hint={t('payout.stats.pending_approval_hint')} tone="warning" />
        <Tile icon={UIcons.UilCheckCircle} label={t('payout.stats.last_payout_date')} value={lastPayoutDate} hint={t('payout.stats.last_payout_date_hint')} tone="success" />
      </div>

      <div className="grid gap-4 md:grid-cols-4">
        <Tile icon={UIcons.UilUsersAlt} label={t('payout.stats.total_winners')} value={totalWinners} hint={t('payout.stats.total_winners_hint')} tone="primary" />
        <Tile icon={UIcons.UilCheckCircle} label={t('payout.stats.paid_winners')} value={paidWinners} hint={t('payout.stats.paid_winners_hint', { percent: paidWinnersPercent })} tone="success" />
        <Tile icon={UIcons.UilClockThree} label={t('payout.stats.pending_winners')} value={pendingWinners} hint={t('payout.stats.pending_winners_hint', { percent: pendingWinnersPercent })} tone="warning" />
        <Tile icon={UIcons.UilGift} label={t('payout.stats.prize_types')} value={prizeTypes} hint={t('payout.stats.prize_types_hint')} tone="purple" />
      </div>
    </div>
  )
})
